import React from "react";
import { Check, X, Clock, AlertTriangle, CircleDashed, Undo2 } from "lucide-react";

const MAP = {
  approved: { label: "Approved", cls: "bg-emerald-100 text-emerald-700", Icon: Check },
  overdue: { label: "Overdue", cls: "bg-red-100 text-red-700", Icon: AlertTriangle },
  rejected: { label: "Rejected", cls: "bg-red-100 text-red-700", Icon: X },
  returned: { label: "Returned", cls: "bg-amber-100 text-amber-700", Icon: Undo2 },
  pending: { label: "Awaiting approval", cls: "bg-sky-100 text-sky-700", Icon: Clock },
  not_submitted: { label: "Not submitted", cls: "bg-slate-100 text-slate-600", Icon: CircleDashed },
};

export default function DocStatusBadge({ status, testId }) {
  const m = MAP[status] || MAP.pending;
  const Icon = m.Icon;
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold ${m.cls}`}>
      <Icon className="h-3 w-3" /> {m.label}
    </span>
  );
}
